// 날짜 줄여 쓰기. 서버(ledger.parse_date)와 같은 규칙이다.
// 구분 기호(/ - . 년월일, 공백)는 떼고 숫자만 본다:
//   20260321·260321 → 연월일, 0321 → 그 해의 월일, 21 → 그 달의 일
// '그 해·그 달'은 보고 있는 대장의 연·월이다. 읽을 수 없으면 null, 읽으면 'YYYY-MM-DD'.
const pad = (n) => String(n).padStart(2, '0');

export const parseDateText = (text, year, month) => {
  const cleaned = String(text == null ? '' : text).trim().replace(/[T\s]\d{1,2}:\d{2}.*$/, '');
  const parts = cleaned.split(/[\s./\-년월일]+/).filter(Boolean);
  if (!parts.length || !parts.every((p) => /^\d+$/.test(p))) return null;
  let y = null;
  let m = null;
  let d = null;
  if (parts.length === 3) [y, m, d] = parts;
  else if (parts.length === 2) [m, d] = parts;
  else if (parts.length === 1) {
    const s = parts[0];
    if (s.length === 8) [y, m, d] = [s.slice(0, 4), s.slice(4, 6), s.slice(6)];
    else if (s.length === 6) [y, m, d] = [s.slice(0, 2), s.slice(2, 4), s.slice(4)];
    else if (s.length === 4) [m, d] = [s.slice(0, 2), s.slice(2)];
    else if (s.length <= 2) d = s;
    else return null;
  } else return null;
  y = y == null ? year : Number(y);
  m = m == null ? month : Number(m);
  d = Number(d);
  if (!y || !m) return null;
  if (y < 100) y += 2000;
  const check = new Date(Date.UTC(y, m - 1, d));
  if (check.getUTCFullYear() !== y || check.getUTCMonth() !== m - 1 || check.getUTCDate() !== d) return null;
  return `${y}-${pad(m)}-${pad(d)}`;
};

export const DATE_HELP = '2026-03-21, 260321, 0321(그 해), 21(그 달) 처럼 넣어 주세요';

// 달력 열기: 숨겨 둔 <input type="date"> 의 고르는 창을 띄운다
export const openPicker = (input) => {
  if (!input) return;
  if (typeof input.showPicker === 'function') input.showPicker();
  else input.focus();
};
